import React from 'react';

import { Helmet } from 'react-helmet';
import { Navigate, useLocation, useParams } from 'react-router-dom';

import { Box, Container } from '@mui/material';

import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';
import { expandTabRoutes, preRegisterSpotlightRoutes } from '~/components/Common/Spotlight/SpotlightProvider';

import PageHeader from '../Common/Elements/PageHeader';

import { curationTabs, curationTabsList, searchCurationTabs, searchCurationTabsList } from './ContentTabs';

preRegisterSpotlightRoutes(expandTabRoutes('/curation', 'Curation', curationTabs));
preRegisterSpotlightRoutes(expandTabRoutes('/search', 'Search', searchCurationTabs));

interface TabConfig {
  title: string;
  component: React.ElementType;
}

export default function CurationPageContainer() {
  const { tab } = useParams<{ tab: string }>();
  const { pathname } = useLocation();
  const isSearchPage = pathname === '/search' || pathname.startsWith('/search/');
  const basePath = isSearchPage ? '/search' : '/curation';
  const tabs: Record<string, TabConfig> = isSearchPage ? searchCurationTabs : curationTabs;
  const tabsList: Array<string> = isSearchPage ? searchCurationTabsList : curationTabsList;
  const currentTab = tabs[tab];

  if (!currentTab) {
    return <Navigate to={`${basePath}/${tabsList[0]}`} replace />;
  }

  const title = `${isSearchPage ? 'Search' : 'Curation'} / ${currentTab.title}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container maxWidth={isSearchPage ? false : 'xl'}>
        <PageHeader title={title} />

        <SectionNavigationLayout
          navigation={
            <SectionNavigation
              label={isSearchPage ? 'Search sections' : 'Curation sections'}
              currentTab={tab}
              groups={[
                {
                  items: tabsList.map((id) => ({
                    id,
                    label: tabs[id].title,

                    href: `${basePath}/${id}`,
                  })),
                },
              ]}
            />
          }
        >
          <Box component={currentTab.component} />
        </SectionNavigationLayout>
      </Container>
    </>
  );
}
